import { render } from "./Bonus_setting.vue?vue&type=template&id=0bcb987e"
import script from "./Bonus_setting.vue?vue&type=script&lang=js"
export * from "./Bonus_setting.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jean/Desktop/Git-project/distell_invoice_backend_dist/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__